import { Component, Input } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { UserBaseModel } from 'src/app/core/models/members/user/user-base.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { UserListService } from 'src/app/core/services/list-services/user-list.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalComponent } from 'src/app/global-component';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { DefaultImageService } from 'src/app/core/services/default-image.service';
import { RequisitionModel } from 'src/app/core/models/requisition/requisition.model';

@Component({
  selector: 'app-assignee-modal',
  templateUrl: './assignee-modal.component.html',
  styleUrls: ['./assignee-modal.component.scss']
})
export class AssigneeModalComponent extends BaseModalComponent {

  protected unsubscribe: Subscription[] = [];
  protected userListItems: UserBaseModel[] = [];
  protected assigneeUserListItems: UserBaseModel[] = [];
  protected userListLoading: boolean = false;
  protected searchTerm: string = '';
  private timeout: any = null;
  protected override defaultImageService: DefaultImageService = new DefaultImageService();

  @Input() public assigneesList: UserBaseModel[] = [];
  @Input() public assigneeIds: string[] = [];
  @Input() public updateOnUpdate: boolean | undefined = undefined;
  @Input() public requisitionModel: RequisitionModel | undefined = undefined;

  public modelChanged: boolean = false;

  constructor(
    protected userListService: UserListService,
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer,
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
  }

  override ngOnInit(): void {

  

    this.userListService.pageSizeNoSearch = GlobalComponent.defaultPagingInfo.maximumSearchDepth;
    const sub = this.userListService.loading$.subscribe((result) => {
      this.userListLoading = result;
    });
    this.unsubscribe.push(sub);

    const sub2 = this.userListService.resultItems$.subscribe((result) => {

      var indexOfCurrentUser = result.findIndex(x => x.id === this.authMyFileService.currentUserContextValue?.id);

      if (indexOfCurrentUser >= 0) {
        result.splice(indexOfCurrentUser, 1);
      }

      if (this.requisitionModel) {
        var indexOfOwner = result.findIndex(x => x.id === this.requisitionModel?.createdById);

        if (indexOfOwner >= 0) {
          result.splice(indexOfOwner, 1);
        }

        if(this.requisitionModel.clientId == undefined || this.requisitionModel.clientId.length == 0){
          this.requisitionModel.clientId = this.requisitionModel.client.id!;
        }
        if(this.requisitionModel.accountId == undefined || this.requisitionModel.accountId.length == 0){
          this.requisitionModel.accountId = this.requisitionModel.account.id!;
        }
      }

      this.userListItems = Object.assign([], result);
      this.assigneesList = [];
      this.userListItems.forEach((userModel) => {
        this.getEntityPhoto(userModel, EntityTypeEnum.User);
        if (this.checkIfUserIsAnAssignee(userModel) !== false) {
          userModel.isInList = true;
          this.assigneesList.push(userModel);
        }
      });

    });
    this.unsubscribe.push(sub2);

    this.userListService.refresh();
  }

  checkIfUserIsAnAssignee(user: UserBaseModel): boolean | number {
    var index = -1;
    if (this.assigneeIds != undefined && this.assigneeIds.length > 0) {
      index = this.assigneeIds.findIndex(x => x === user.id);
    }
    if (index !== -1) {
      return index;
    }
    return false;
  }

  override ngOnDestroy(): void {
    this.updateOnUpdate = undefined;
    this.requisitionModel = undefined;
    this.assigneesList = [];
    this.assigneeIds = [];
    this.modelChanged = false;
    this.userListService.clearListService();
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
  override validate(): boolean {
    return false;
  }

  override onUpdate(): void {
    if (this.modelChanged) {
      Swal.fire({
        title: $localize`:@@:Confirm Changes`,
        text: $localize`:@@:Are you sure you want to update the assignees?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Yes`,
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        cancelButtonText: $localize`:@@:Cancel`,
      }).then(result => {
        if (result.isConfirmed) {
          this.update();
        } else {
          this.close();
        }
      });
    } else {
      this.update();
    }

  }

  update() {
    if (this.updateOnUpdate == true && this.requisitionModel !== undefined) {
      this.userListLoading = true;
      this.requisitionModel.assigneeIds = this.assigneeIds;
      this.requisitionModel.assignees = this.assigneesList;
      var sub = this.myFileApiService.updateRequisition(this.requisitionModel).subscribe(result => {
        this.userListLoading = false;
        sub.unsubscribe();
        this.close();
      })
    } else {
      this.close();
    }
  }

  override onCreate(): void {
  }

  searchTermUpdated() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(() => {
      this.userListService.searchTerm = this.searchTerm;
    }, 500);
  }

  addToListOfAssignees(user: UserBaseModel) {
    if (this.assigneesList == undefined) {
      this.assigneesList = [];
    }
    if (this.assigneeIds == undefined) {
      this.assigneeIds = [];
    }

    if (this.assigneesList.findIndex(x => x.id === user.id) == -1) {

      user.isInList = true;
      this.modelChanged = true;
      this.getEntityPhoto(user, EntityTypeEnum.User);

      this.assigneesList.push(user);
      this.assigneeIds.push(user.id!);
    }

  }

  removeUserFromListOfAssignees(user: UserBaseModel) {
    var assigneeListIndex = this.assigneesList.findIndex(x => x.id === user.id);
    if (assigneeListIndex !== -1) {
      user.isInList = false;
      this.modelChanged = true;
      this.assigneesList.splice(assigneeListIndex, 1);
    }
    var assigneeIdsIndex = this.assigneeIds.findIndex(x => x === user.id);
    if (assigneeIdsIndex !== -1) {
      this.assigneeIds.splice(assigneeIdsIndex, 1);
    }
  }

  removeFromListOfAssignees(assignee: UserBaseModel) {
    Swal.fire({
      title: $localize`:@@:Remove ${assignee.fullName}`,
      text: $localize`:@@:Are you sure you want to remove this assignee?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Yes`,
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      cancelButtonText: $localize`:@@:Cancel`,
    }).then(result => {
      if (result.isConfirmed) {
        this.removeUserFromListOfAssignees(assignee);
        this.modelChanged = true;
        this.userListService.pageIndex = this.userListService.pageIndex;
      }
    });
  }

  getEntityPhoto(entity: any, entityTypeEnum: EntityTypeEnum) {
    entity.listPhoto = this.defaultImageService.getDefaultUserImage(entity.fullName);
    if (entity.id && entity.profilePhotoFileId) {
      this.myFileApiService.getEntityFile(entityTypeEnum, entity.id, entity.profilePhotoFileId).subscribe(result => {
        if (result) {
          var reader = new FileReader();
          reader.readAsDataURL(result);
          reader.onload = () => {
            if (reader.result) {
              var sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${reader.result.toString().split(',')[1]}`);
              entity.listPhoto = sanitizedUrl;
            }
          }
        }
      })
    }

  }
}
